const LOCAL_TURNSTILE_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

export function isTurnstileEnabled() {
  if (typeof window === 'undefined') {
    return false;
  }

  const { hostname, protocol } = window.location;
  if (protocol === 'file:') {
    return false;
  }

  return !LOCAL_TURNSTILE_HOSTS.has(hostname);
}